import Cookies from 'js-cookie';
import React, { useState, useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { Variables } from '../../Variables1/Variables';
import { ToastContainer, toast } from 'react-toastify';
import axios from 'axios';
import CustomSnipper from '../../components/customSnipper';
import { Button, Form, Spinner, Row, Col ,Image, FormCheck, Card } from 'react-bootstrap';

const ManageAbout = (props) => {
    const AboutRouteId = useParams();
  const navigate = useNavigate();
  const token = Cookies.get("token");
//   const [Permissions, setPermissions] = useState(
//     Util.decrypt(localStorage.getItem("rpmRRTLx12"))
//   );

  const [aboutId, setAboutId] = useState(
    Number(AboutRouteId.AboutRouteId) || 0
  );

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const [aboutExist, setAboutExist] = useState(null);


  // const [title, setTitle] = useState(null);
  // const [date, setDate] = useState(null);
  // const [isPublished, setIsPublished] = useState(null);
  // const [text, setText] = useState(null);

  const [aboutDetails, setAboutDetails] = useState({
    AboutId: 0,
    Title: "",
    IsPublished: true,
    BackImageUrl: "",
    FrontImageUrl: "",
    Text: ""
  });

  const [backImageUrl, setBackImageUrl] = useState("");
  const [backImageUrlToDb, setBackImageUrlToDb] = useState("");

  const [frontImageUrl, setFrontImageUrl] = useState("");
  const [frontImageUrlToDb, setFrontImageUrlToDb] = useState("");



  const [image, setImage] = useState("");
  const [imageToDb, setImageToDb] = useState("");

//   const [thumbnail, setThumbnail] = useState("");
//   const [thumbnailToDb, setThumbnailToDb] = useState("");

// get content details
const GetAboutDetails = async () => {
    let response = await fetch(
      Variables.API_URL + "About/GetAboutDetails/" + aboutId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      setAboutDetails({
        AboutId: result.AboutId,
        Title: result.Title,
        Text: result.Text,
        IsPublished: result.IsPublished,
        FrontImageUrl: result.FrontImageUrl,
        BackImageUrl: result.BackImageUrl,
      });
        // setTitle(result.title);
        // setDate(result.date);
        // setBackImageUrl(result.BackImageUrl);
        // setFrontImageUrl(result.FrontImageUrl);
        // setIsPublished(result.IsPublished);

      setAboutExist(true);
    } else {
        setAboutExist(false);
    }
  };
  // handle Inputs
  const handleInputs = (e) => {
    const { name, value } = e.target;
    var element;
    if (value === "" || value === "0") {
      element = document.getElementById(name);
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById(name);
      element.classList.remove("is-invalid");
    }
    setAboutDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };


const SetImage = (e) => {
  var x = e.target.files[0];
  let reader = new FileReader();
  reader.onload = function (e) {
    if (
      e.target.result.indexOf("png") >= 0 ||
      e.target.result.indexOf("jpeg") >= 0 ||
      e.target.result.indexOf("jpg") >= 0
    ) {
      setImageToDb(x);
      setImage(e.target.result);
    } else {
      toast.error("File type error", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };
  reader.readAsDataURL(e.target.files[0]);
  var element = document.getElementById("ImageUrlBack");
  var element2 = document.getElementById("ImageUrlFront");

  element.classList.remove("is-invalid");
  element2.classList.remove("is-invalid");

};



  // Set Image
  const SetBackImage = (e) => {
    var x = e.target.files[0];
    let reader = new FileReader();
    reader.onload = function (e) {
      if (
        e.target.result.indexOf("png") >= 0 ||
        e.target.result.indexOf("jpeg") >= 0 ||
        e.target.result.indexOf("jpg") >= 0
      ) {
        setBackImageUrlToDb(x);
        setBackImageUrl(e.target.result);
      } else {
        toast.error("File type error", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
    reader.readAsDataURL(e.target.files[0]);
    var element = document.getElementById("ImageUrlBack");
    element.classList.remove("is-invalid");
  };

  // Set Image
  const SetFrontImage = (e) => {
    var x = e.target.files[0];
    let reader = new FileReader();
    reader.onload = function (e) {
      if (
        e.target.result.indexOf("png") >= 0 ||
        e.target.result.indexOf("jpeg") >= 0 ||
        e.target.result.indexOf("jpg") >= 0
      ) {
        setFrontImageUrlToDb(x);
        setFrontImageUrl(e.target.result);
      } else {
        toast.error("File type error", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }
    };
    reader.readAsDataURL(e.target.files[0]);
    var element = document.getElementById("ImageUrlFront");
    element.classList.remove("is-invalid");
  };

   // Handle IsPublished
   const HandleIsPublished = () => {
    if (aboutDetails.IsPublished === true) {
      setAboutDetails((prevState) => ({
        ...prevState,
        IsPublished: false,
      }));
    // setIsPublished(false)
    } else {
        setAboutDetails((prevState) => ({
        ...prevState,
        IsPublished: true,
      }));
    // setIsPublished(true)

    }
  };

  //#endregion

  // Check input validity
  function IsValid() {
    var hasError = false;
    var element;
    if (aboutDetails.Title === null || aboutDetails.Title === "") {
      element = document.getElementById("Title");
      element.classList.add("is-invalid");
      element.focus();
      hasError = true;
    }
   
         if (
          aboutDetails.Text === null ||
          aboutDetails.Text === ""
    ) {
      element = document.getElementById("Text");
      element.classList.add("is-invalid");
      element.focus();
      hasError = true;
    }
    // if (contentDetails.SubTitle === null || contentDetails.SubTitle === "") {
    //   element = document.getElementById("SubTitle");
    //   element.classList.add("is-invalid");
    //   element.focus();
    //   hasError = true;
    // }
    // if (date === null || date === "") {
    //   element = document.getElementById("Date");
    //   element.classList.add("is-invalid");
    //   element.focus();
    //   hasError = true;
    // }

   

    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

//   function getDateFromDetails(x) {
//     var x = contentDetails.EventStartDate.split("-");
//     return new Date(x[0], x[1], x[2]);
//   }

  const AddNewAbout = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "About/AddAbout", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        // Title: title,
        // BackImageUrl: backImageUrl,
        // FrontImageUrl: frontImageUrl,
        // Text: text,
        // IsPublished: isPublished,
        Details: aboutDetails,
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success("Content Added Successfully", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      if(backImageUrlToDb != "" && frontImageUrlToDb != ""){
        const formData = new FormData();
        formData.append("BackImage", backImageUrlToDb);
        formData.append("AboutId", result);
        formData.append("FrontImage", frontImageUrlToDb);


   
  
        const resImage = await axios.post(
          Variables.API_URL + "About/UploadAboutMedia",
          formData,{
            headers:{
              Authorization: `Bearer ${token}`,
            }
          }
        );


  
        
      }

      // if(backImageUrlToDb != ""){
      //   const formData = new FormData();
      //   formData.append("BackImage", backImageUrlToDb);
      //   formData.append("AboutId", result);
  
      //   const resImage = await axios.post(
      //     Variables.API_URL + "About/UploadAboutMedia",
      //     formData,{
      //       headers:{
      //         Authorization: `Bearer ${token}`,
      //       }
      //     }
      //   );
      // }
      // if(frontImageUrlToDb != ""){
      //   const formData = new FormData();
      //   formData.append("FrontImage", frontImageUrlToDb);
      //   formData.append("AboutId", result);
  
      //   const resImage = await axios.post(
      //     Variables.API_URL + "About/UploadAboutMedia",
      //     formData,{
      //       headers:{
      //         Authorization: `Bearer ${token}`,
      //       }
      //     }
      //   );
      // }


      

      setTimeout(() => {
        navigate("/About");
      }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // Add new About
  const UpdateAbout = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "About/UpdateAbout", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        // Title: title,
        // BackImageUrl: backImageUrl,
        // FrontImageUrl: frontImageUrl,
        // Text: text,
        // IsPublished: isPublished,
        Details: aboutDetails,
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      if(backImageUrlToDb != ""){
        const formData = new FormData();
        formData.append("BackImage", backImageUrlToDb);
        formData.append("AboutId", aboutDetails.AboutId);
  
        const resImage = await axios.post(
          Variables.API_URL + "About/UploadAboutMedia",
          formData,{
            headers:{
              Authorization: `Bearer ${token}`,
            }
          }
        );
      }
      if(frontImageUrlToDb != ""){
        const formData = new FormData();
        formData.append("FrontImage", frontImageUrlToDb);
        formData.append("AboutId", aboutDetails.AboutId);
  
        const resImage = await axios.post(
          Variables.API_URL + "About/UploadAboutMedia",
          formData,{
            headers:{
              Authorization: `Bearer ${token}`,
            }
          }
        );
      }
      setTimeout(() => {
        navigate("/About");
    }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // Handle Sumbit
  const HandleSumbit = async () => {
    var isValid = IsValid();
    if (isValid) {
      // case of insert
      if (aboutId === 0) {
        AddNewAbout();
      }
      // case of update
      else {
        UpdateAbout();
      }
    } else {
      toast.error("Please Fill All Required Fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {

    if (aboutId != 0) {
      GetAboutDetails();
    }
  }, []);


  return (
    <div>
      <Row>
        <Col sm="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  {aboutId === 0
                    ? "Add New About"
                    : "Manage About --> " + aboutDetails.Title}
                </h4>
              </div>
            </Card.Header>
            <Card.Body>
              {loader === true ? (
                <CustomSnipper />
              ) : (
                <div>
                  <Row>
                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Title :</Form.Label>
                      <Form.Control
                        id="Title"
                        name="Title"
                        placeholder="Title"
                        type="text"
                        value={aboutDetails.Title}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    

                    {/* <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Date :</Form.Label>
                      <Form.Control
                        id="Date"
                        name="Date"
                        placeholder="Date"
                        type="Date"
                        value={date}
                        onChange={(e) => setTitle(e.target.value)}
                      />
                    </Form.Group> */}


                    <Form.Group className="col-md-3 form-group">
                      <Form.Label htmlFor="fname">.</Form.Label>
                      <Form.Check className="mb-3 form-check">
                        <FormCheck.Input
                          type="checkbox"
                          className=""
                          id="Published"
                          checked={aboutDetails.IsPublished}
                          onChange={(e) => HandleIsPublished()}
                        />
                        <FormCheck.Label className="" htmlFor="exampleCheck1">
                          IsPublished
                        </FormCheck.Label>
                      </Form.Check>
                    </Form.Group>

                    

                    

                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">Text :</Form.Label>
                      <textarea
                        className="form-control"
                        aria-label="With textarea"
                        id="Text"
                        name="Text"
                        placeholder="Text"
                        type="textarea"
                        value={aboutDetails.Text}
                        onChange={handleInputs}
                      ></textarea>
                    </Form.Group>
                    

                    <Form.Group className="col-lg-6 col-md-12 col-sm-12 form-group">
                      <Row>
                        <Form.Group>
                          <Form.Label className="custom-file-input">
                            Choose Back Image
                          </Form.Label>
                          <Form.Control
                            id="ImageUrlBack"
                            name="ImageUrlBack"
                            placeholder="Image"
                            type="file"
                            accept="image/*"
                            onChange={SetBackImage}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Col className="allignCenter">
                          {backImageUrl !== "" ? (
                            <div>
                              <img
                                src={backImageUrl}
                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                alt="Boat on Calm Water"
                              />
                            </div>
                          ) : aboutDetails.BackImageUrl !== "" &&
                          aboutDetails.BackImageUrl !== null ? (
                            <div>
                              <img
                                src={
                                  Variables.imagePath + aboutDetails.BackImageUrl
                                }
                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                alt="Boat on Calm Water"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </Form.Group>




                    <Form.Group className="col-lg-6 col-md-12 col-sm-12 form-group">
                      <Row>
                        <Form.Group>
                          <Form.Label className="custom-file-input">
                            Choose Front Image
                          </Form.Label>
                          <Form.Control
                            id="ImageUrlFront"
                            name="ImageUrlFront"
                            placeholder="Image"
                            type="file"
                            accept="image/*"
                            onChange={SetFrontImage}
                          />
                        </Form.Group>
                      </Row>
                      <Row>
                        <Col className="allignCenter">
                          {frontImageUrl !== "" ? (
                            <div>
                              <img
                                src={frontImageUrl}
                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                alt="Boat on Calm Water"
                              />
                            </div>
                          ) :aboutDetails.FrontImageUrl !== "" &&
                          aboutDetails.FrontImageUrl !== null ? (
                            <div>
                              <img
                                src={
                                  Variables.imagePath + aboutDetails.FrontImageUrl
                                }
                                className="w-100 shadow-1-strong rounded mb-4 img-200 image-log sqaureImage"
                                alt="Boat on Calm Water"
                              />
                            </div>
                          ) : (
                            ""
                          )}
                        </Col>
                      </Row>
                    </Form.Group>

                    

                    
                  </Row>
                </div>
              )}
              <hr />

              <div className="float-right">
                <Button
                  type="button"
                  variant="btn btn-primary"
                  onClick={HandleSumbit}
                >
                  {buttonLoader == true ? (
                    <Spinner animation="border" variant="light" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  ) : (
                    "Submit"
                  )}
                </Button>{" "}
                <Button
                  type="button"
                  variant="btn btn-secondary"
                  onClick={() => navigate("/About")}
                >
                  Cancel
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  )
}

export default ManageAbout